/* External Imports */
import { Box } from '@chakra-ui/react';
import { useEffect } from 'react';

/* Internal Imports */
/* Components */
import StructuredTextContent from '@components/UI/StructuredTextContent';

/* Services */

/**
 * Renders the Doubts Clarify content component
 * @param {Object} sectionContent - Data for section
 * @param {string} region - Region of the section
 * @param {string} lang - Language of the section
 * @returns {ReactElement} SDoubts Clarify content component
 */

const DoubtsClarify = ({ section, region, language, csrData }) => {
  const emailSupport = csrData => {
    let onlineSupport = document.querySelector('.onlinecontact');
    let prgm_support_email = '';
    let onlineSupportEmail = '';
    if (csrData) {
      prgm_support_email = csrData?.result[0]?.regional_support_email;
    }
    if (onlineSupport && csrData && csrData?.result[0]?.regional_support_email) {
      onlineSupportEmail = ` <a href=mailto:${prgm_support_email}>${prgm_support_email}</a>`;
      onlineSupport.innerHTML = onlineSupportEmail;
    }
    if (csrData && prgm_support_email != false) {
      prgm_support_email?.includes('@')
        ? (onlineSupportEmail = ` <a href=mailto:${prgm_support_email || ''}>${
            prgm_support_email || ''
          }</a>`)
        : (onlineSupportEmail = ` <a href=${prgm_support_email || ''}>${
            prgm_support_email || ''
          }</a>`);
      if (onlineSupport) {
        onlineSupport.innerHTML = onlineSupportEmail;
      }
    }
  };

  useEffect( () => {
    emailSupport(csrData);
  }, [csrData]);

  const moduledata = section;
  return (
    <Box>
      <Box
        as="div"
        fontFamily="FedraSansStd-book"
        width={{ base: '90%', sm: '90%', md: '400px', lg: '400px' }}
        m="0 auto 50px auto"
        className={`contactus ${language != 'en' ? language : ''}`}
      >
        <Box
          as="div"
          fontFamily="FedraSerifAStdBook"
          fontSize={{
            base: '24px',
            md: '34px',
          }}
          fontWeight={{
            base: '600',
            md: '600',
          }}
          lineHeight="1.1"
          color={'#28231E'}
          textAlign="center"
          m={{ base: '20px auto 0 auto', md: '40px auto 0 auto' }}
        >
          {moduledata[0]?.text}
        </Box>
        <Box
          as="div"
          fontFamily="FedraSansStd-book, sans-serif"
          fontSize={{ base: '18px', md: '18px', lg: '18px' }}
          textAlign="center"
          color="#444444"
          m="6px 0 20px 0"
        >
          {moduledata[1]?.titleText}
        </Box>
        {region === 'us' && (
          <>
            <Box
              as="div"
              width="90%"
              m="0 auto"
              position="relative"
              top="-10px"
              textAlign="center"
              className="sannidhi-text contactus"
            >
              {StructuredTextContent(moduledata[3]?.body?.value)}
            </Box>
          </>
        )}
        {region !== 'in' && (
          <>
            {moduledata[3]?.text != '' && region !== 'us' && (
              <Box
                as="div"
                m="0 auto"
                className="sannidhi-text contactus"
                display="block"
                textAlign="center"
              >
                <Box display={{ base: 'block', md: 'inline-flex' }} as="span">
                  {moduledata[3]?.text} {'  '}
                </Box>
                <Box as="span" className="onlinecontact"></Box>
              </Box>
            )}
          </>
        )}
        {region === 'in' && (
          <>
            <Box
              as="div"
              width="90%"
              m="0 auto"
              className="sannidhi-text contactus"
            >
              {StructuredTextContent(moduledata[2]?.body?.value)}
            </Box>
          </>
        )}
        <style global jsx>
          {`
            .clear {
              clear: both;
            }
            .contactus {
              color: #444444;
              position: relative;
              font-size: 16px;
            }
            .contactus mark,
            .contactus a mark {
              background: transparent;
              color: #cf4520;
              position: absolute;
              left: 84px;
            }
            .contactus.ta mark, .contactus.ta a mark {
              left: 130px;
            }
            .contactus p {
              line-height: 32px;
            }
            @media (max-width: 767px) {
              .contactus {
                font-size: 14px;
              }
              .contactus p,
              .contactus a mark {
                text-align: center;
                font-size: 14px;
              }
              .contactus a mark {
                left: 13%;
              }
              .contactus {
                position: inherit;
              }
              .contactus mark {
                position: static;
                left: 0;
                display: block;
                text-align: center;
              }
            }
          `}
        </style>
      </Box>
    </Box>
  );
};

export default DoubtsClarify;
